import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { MoreSheet } from '@/components/layout/MoreSheet'
import { useUnreadAlertCount } from '@/lib/useAlerts'

interface TabDef {
  to: string
  label: string
}

const TABS: TabDef[] = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/positions', label: 'Portfolio' },
  { to: '/alerts', label: 'Alerts' },
  { to: '/events', label: 'Events' },
]

const TAB_BASE =
  'relative flex flex-1 flex-col items-center justify-center gap-0.5 px-1 py-2 font-mono text-[10px]'

export function BottomNav() {
  const [moreOpen, setMoreOpen] = useState(false)
  const { data: unreadCount = 0 } = useUnreadAlertCount()

  return (
    <>
      <nav
        aria-label="Hauptnavigation"
        className="fixed inset-x-0 bottom-0 z-30 flex h-14 border-t border-hairline bg-panel md:hidden"
      >
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              [
                TAB_BASE,
                isActive
                  ? 'border-t-2 border-bernstein pt-1.5 text-bernstein'
                  : 'text-muted hover:text-ink',
              ].join(' ')
            }
          >
            <span>{tab.label}</span>
            {tab.to === '/alerts' && unreadCount > 0 && (
              <span
                aria-hidden="true"
                className="absolute top-1 right-1/4 rounded-full bg-bernstein px-1.5 text-[9px] text-void"
              >
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </NavLink>
        ))}
        <button
          type="button"
          onClick={() => setMoreOpen(true)}
          aria-label="Mehr"
          className={[TAB_BASE, 'text-muted hover:text-ink'].join(' ')}
        >
          <span>Mehr ⋯</span>
        </button>
      </nav>
      <MoreSheet open={moreOpen} onClose={() => setMoreOpen(false)} />
    </>
  )
}
